import { MobileDemoUsersModalComponent } from './../mobile-demo-users-modal/mobile-demo-users-modal.component';
import { NgbModal, NgbModalRef, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { liveUsersModal } from "./liveUsers.component";
import { MobileLiveUsersModalComponent } from '../mobile-live-users-modal/mobile-live-users-modal.component';

export function showLiveUsersModal(modalService: NgbModal, idToEdit = 0, mobileMode = 'desktop') {
    const mobile = mobileMode != 'desktop';
    const component = mobile? MobileLiveUsersModalComponent: liveUsersModal;
    const windowClass = "dark-modal" + (mobile? ' mobile': '');
    let opt: NgbModalOptions = {
        backdrop: "static",
        centered: true,
        windowClass: windowClass,
        size: "sm"
    };
    let m: NgbModalRef = modalService.open(component, opt);
    let modal = (<liveUsersModal>m.componentInstance);

    if(idToEdit != 0)
    {
       
        modal.dissmissAfterEdit = true;
        modal.modalSubType = "standard";
    }
}

